export default __webpack_public_path__ + "static/media/img_tutorial_main.1eaa6c15.png";